import _Vue from "vue"
    
class LongPressPlugin {
  public install(Vue: typeof _Vue) {
    
    Vue.directive('longclick', {
      bind: function bind(el, binding, vNode) {
        
        var pressTimer: any = null;
        var pressInterval: any = null;
  
        var start = function start(event) {
          const key = event.key || event.keyCode

          if (key != 'Enter') {
            return;
          }
  
          if (pressTimer === null) {
            pressTimer = setTimeout(function () {
              
              pressInterval = setInterval(function () {
                binding.value(event);
              }, 50);              

              binding.value(event);
            }, 400);
          }
        }; // Cancel Timeout
  
  
        var cancel = function cancel() {
          if (pressTimer !== null) {
            clearTimeout(pressTimer);
            pressTimer = null;
          }
  
          if (pressInterval) {
            clearInterval(pressInterval);
            pressInterval = null;
          }
        }; // Run Function
  
        ['keydown'].forEach(function (e) {
          return el.addEventListener(e, start);
        });
        ['keyup'].forEach(function (e) {
          return el.addEventListener(e, cancel);
        });
      }
    })
    
  }
}

export default new LongPressPlugin() ;
